import storage from "good-storage";

export const ENV = "PROD";
// export const ENV = "TEST";

const API_CFG = {
    DEV: {
        protocol: "http",
        host: "106.13.89.61",
        port: "9002",
        prefix: ""
    },
    TEST: {
        protocol: "http",
        host: "test-api-2.laoniuche.cn",
        port: "443",
        prefix: ""
    },
    PROD: {
        protocol: "https",
        host: "api-2.yunhaogroup.com",
        port: "443",
        prefix: ""
    },
}

//门户2请求环境
const baseAuthRequestUrl = {
    "DEV": "http://api.peijian88.cn",
	"STAGE": "http://api.beiben88.com",
	"TEST": "http://test-api-2.laoniuche.cn",
	"PROD": "https://api-2.yunhaogroup.com"
}

//自动获取请求地址
export const getBaseRequestUrl = () => {
    const REACT_APP_ENV = process.env.REACT_APP_ENV;
    return baseAuthRequestUrl[REACT_APP_ENV ?? ENV] + "/scm-zjk-2" 
};
//根据环境变量自动获取鉴权请求地址
export const getBaseAuthRequestUrl = () => {
    const REACT_APP_ENV = process.env.REACT_APP_ENV;
    return baseAuthRequestUrl[REACT_APP_ENV ?? ENV];
};


export function getAuthApiBaseUrl() {
    return API_CFG[ENV].protocol + "://" + API_CFG[ENV].host + ":" + API_CFG[ENV].port + "/auth";
}

export const CM_ACTION_TYPE = {
    INSERT: 0,
    EDIT: 1,
    DETAIL: 2
}

// //localStorage或sessionStorage中存储Token的key值
// const TOKEN_KEY = "Authorization";
// //localStorage或sessionStorage中出处的nav状态数据的key值
// const NAV_CFG_KEY = "navState";
export const DICT_KEY = {
    TOKEN_KEY: "Authorization",
    APP_CODE: "appcode", //code值
    USER_INFO: "userinfo", //用户信息
    USER_MENU: "usermenu",
    NAV_CFG_KEY: "navState",
    APP_RESOURCE: "auth",
    CM_DICT_META: [{
        CODE: "042",
        NAME: "orgDict",
    }, {
        CODE: "WAREHOUSE",
        NAME: "warehouseDict",
    }, {
        CODE: "AREA",
        NAME: "areaDict",
    }, {
        CODE: "SHELVE",
        NAME: "shelveDict",
    }, {
        CODE: "POSITION",
        NAME: "positionDict",
    }, {
        CODE: "032",
        NAME: "brandDict"
    }, {
        CODE: "005",
        NAME: "engineTypeDict",
    }, {
        CODE: "033",
        NAME: "materialUnitDict",
    }, {
        CODE: "003",
        NAME: "materialSortDict",
    }, {
        CODE: "SUPPLIER",
        NAME: "supplierDict",
    }, {
        CODE: "CUSTOMER",
        NAME: "customerDict",
    }, {
        CODE: "002",
        NAME: "supplierTypeDict",
    }, {
        CODE: "001",
        NAME: "customerTypeDict",
    }, {
        CODE: "008",
        NAME: "payTypeDict",
    }, {
        CODE: "",
        NAME: "payStatusDict",
    }, {
        CODE: "018",
        NAME: "whOutStatusDict",
    }, {
        CODE: "",
        NAME: "whInStatusDict",
    }, {
        CODE: "004",
        NAME: "invoiceTypeDict",
    }, {
        CODE: "038",
        NAME: "salePriceTypeDict",
    }, {
        CODE: "015",
        NAME: "saleOrderTypeDict",
    }, {
        CODE: "014",
        NAME: "saleOrderStatusDict",
    }, {
        CODE: "017",
        NAME: "saleStatusDict",
    }, {
        CODE: "019",
        NAME: "salePayStatusDict",
    }, {
        CODE: "029",
        NAME: "saleReturnStatusDict",
    }, {
        CODE: "030",
        NAME: "saleReturnPayStatusDict",
    }, {
        CODE: "007",
        NAME: "purchaseOrderTypeDict",
    }, {
        CODE: "",
        NAME: "purchaseOrderStatusDict",
    }, {
        CODE: "",
        NAME: "purchaseInvoiceStatusDict",
    }, {
        CODE: "025",
        NAME: "purchaseStatusDict",
    }, {
        CODE: "026",
        NAME: "purchasePayStatusDict",
    }, {
        CODE: "027",
        NAME: "purchaseReturnStatusDict",
    }, {
        CODE: "028",
        NAME: "purchaseReturnPayStatusDict",
    }, {
        CODE: "031",
        NAME: "stockCheckStatusDict",
    }, {
        CODE: "009",
        NAME: "accountTypeDict",
    }, {
        CODE: "039",
        NAME: "billsTypeDict",
    }, {
        CODE: "040",
        NAME: "payeeTypeDict",
    }, {
        CODE: "036",
        NAME: "bankTypeDict",
    }],
    CM_DICT: {
        //组织机构
        ORG: "cmDict.orgDict",
        //仓库
        WAREHOUSE: "cmDict.warehouseDict",
        //区域
        AREA: "cmDict.areaDict",
        //货位
        SHELVE: "cmDict.shelveDict",
        //货位
        POSITION: "cmDict.positionDict",
        //品牌
        BRAND: "cmDict.brandDict",
        //发动机型号
        ENGINE_TYPE: "cmDict.engineTypeDict",
        //计量单位
        MATERIAL_UNIT: "cmDict.materialUnitDict",
        //配件类型
        MATERIAL_SORT: "cmDict.materialSortDict",
        //供应商列表
        SUPPLIER: "cmDict.supplierDict",
        //客户列表
        CUSTOMER: "cmDict.customerDict",
        //供应商类型
        SUPPLIER_TYPE: "cmDict.supplierTypeDict",
        //客户类型
        CUSTOMER_TYPE: "cmDict.customerTypeDict",
        //支付方式
        PAY_TYPE: "cmDict.payTypeDict",
        //支付状态
        PAY_STATUS: "cmDict.payStatusDict",
        //出库状态
        WH_OUT_STATUS: "cmDict.whOutStatusDict",
        //入库状态
        WH_IN_STATUS: "cmDict.whInStatusDict",
        //发票类型
        INVOICE_TYPE: "cmDict.invoiceTypeDict",
        //销售价格类型
        SALE_PRICE_TYPE: "cmDict.salePriceTypeDict",
        //销售订单类型
        SALE_ORDER_TYPE: "cmDict.saleOrderTypeDict",
        //销售订单状态
        SALE_ORDER_STATUS: "cmDict.saleOrderStatusDict",
        //销售单状态
        SALE_STATUS: "cmDict.saleStatusDict",
        //销售单支付状态
        SALE_PAY_STATUS: "cmDict.salePayStatusDict",
        //销售退货单状态
        SALE_RETURN_STATUS: "cmDict.saleReturnStatusDict",
        //销售退货单支付状态
        SALE_RETURN_PAY_STATUS: "cmDict.saleReturnPayStatusDict",
        //采购订单类型
        PURCHASE_ORDER_TYPE: "cmDict.purchaseOrderTypeDict",
        //采购订单状态
        PURCHASE_ORDER_STATUS: "cmDict.purchaseOrderStatusDict",
        //采购发运单状态
        PURCHASE_INVOICE_STATUS: "cmDict.purchaseInvoiceStatusDict",
        //采购单状态
        PURCHASE_STATUS: "cmDict.purchaseStatusDict",
        //采购单支付状态
        PURCHASE_PAY_STATUS: "cmDict.purchasePayStatusDict",
        //采购退货单状态
        PURCHASE_RETURN_STATUS: "cmDict.purchaseReturnStatusDict",
        //采购退货单支付状态
        PURCHASE_RETURN_PAY_STATUS: "cmDict.purchaseReturnPayStatusDict",
        //盘点状态
        STOCK_CHECK_STATUS: "cmDict.stockCheckStatusDict",
        //账户类型
        ACCOUNT_TYPE: "cmDict.accountTypeDict",
        //单据类型
        BillS_TYPE: "cmDict.billsTypeDict",
        //收款类型
        PAYEE_TYPE: "cmDict.payeeTypeDict",
        //开户银行类型
        OPENBANK_TYPE: "cmDict.bankTypeDict"
    },
    BASE_MATERIAL: "base.material",
    BASE_DICT: "base.dict",
    BASE_SUPPLIER: "base.supplier",
    BASE_CUSTOMER: "base.customer",
    BASE_WAREHOUSE: "base.warehouse",
    SALE_ORDER: "sale.order",
    SALE_SO: "sale.so",
    SALE_RO: "sale.ro",
    PURCHASE_ORDER: "purchase.order",
    PURCHASE_INVOICE: "purchase.invoice",
    PURCHASE_PO: "purchase.po",
    PURCHASE_RO: "purchase.ro",
    BILL_CUSTOMER: "bill.customer",
    BILL_SUPPLIER: "bill.supplier",
    STOCK_CHECK: "stock.check",
    STOCK_STATISTIC: "stock.statistic",
    //保存用户信息
    SUPPLY_USER: "supply.user"
}

export function clearCache(dict = DICT_KEY) {
    for (let key in dict) {
        let dictValue = dict[key];
        if (dictValue) {
            if (dictValue.constructor === String) {
                storage.remove(dictValue);
            } else if (dictValue.constructor === Object) {
                clearCache(dictValue);
            }
        }
    }
}

//保存token
export function setToken(token) {
    storage.session.set(DICT_KEY.TOKEN_KEY, token);
}

//获取token
export function getToken() {
    if (storage.session.has(DICT_KEY.TOKEN_KEY))
        return storage.session.get(DICT_KEY.TOKEN_KEY);
    return null
}

//保存appCode
export function setAppCode(appcode) {
    storage.session.set(DICT_KEY.APP_CODE, appcode);
}

//获取appCode
export function getAppCode() {
    if (storage.session.has(DICT_KEY.APP_CODE))
        return storage.session.get(DICT_KEY.APP_CODE);
    return null
}
//保存资源权限
export function setResources(auth) {
    storage.session.set(DICT_KEY.APP_RESOURCE, auth);
}

//获取资源权限
export function getResources() {
    if (storage.session.has(DICT_KEY.APP_RESOURCE))
        return storage.session.get(DICT_KEY.APP_RESOURCE);
    return null
}

//获取用户信息
export function getUserInfo() {
    return storage.session.get(DICT_KEY.USER_INFO);
}

export function setUserInfo(UserInfo) {
    return storage.session.set(DICT_KEY.USER_INFO, UserInfo);
}

export function removeUserInfo() {
    return storage.session.remove(DICT_KEY.USER_INFO);
}

//获取菜单信息
export function setUserMenu(menuArr) {
    return storage.session.set(DICT_KEY.USER_MENU, menuArr);
}

export function getUserMenuAll() {
    return storage.session.get(DICT_KEY.USER_MENU);
}

export function getUserMenu(path) {
    let userMenu = storage.session.get(DICT_KEY.USER_MENU);
    return userMenu.find(item => item.menuUrl === path);
}

export function removeUserMenu() {
    return storage.session.remove(DICT_KEY.USER_MENU);
}

//保存nav状态
export function setNavState(state) {
    storage.set(DICT_KEY.NAV_CFG_KEY, state);
}

//获取nav状态
export function getNavState() {
    if (storage.has(DICT_KEY.NAV_CFG_KEY))
        return storage.get(DICT_KEY.NAV_CFG_KEY);
    return null
}

export function getCmDict(key) {
    if (storage.has(key))
        return storage.get(key);
    return []
}

export function setCmDict(key, value) {
    storage.set(key, value);
}

export function getModel(key) {
    if (storage.has(key))
        return storage.get(key);
    return null
}

export function setModel(key, value) {
    storage.set(key, value);
}

export function getDictNameByCode(key, dictCode, isTree = false) {
    /*const cmDict = getModelState("cmDict");
    const dictKey = key.split(".")[1];
    const dictData = cmDict[dictKey];*/
    const dictData = getCmDict(key)
    if (dictData) {
        if (isTree) {
            let dict = null;
            const getTreeDictNameByCode = (treeData = []) => {
                for (let i = 0; i < treeData.length; i++) {
                    if (dict) {
                        break;
                    }
                    const el = treeData[i];
                    if (el.value === dictCode) {
                        dict = el;
                        break;
                    } else if (el.children && el.children.length > 0) {
                        getTreeDictNameByCode(el.children)
                    }
                }
            }
            getTreeDictNameByCode(dictData);

            return dict ? dict.title : "";
        } else {
            const dict = dictData.find(el => el.value === dictCode);
            return !!dict ? dict.label : ""
        }
    }
    return "";
}

export function getDictCodeByName(key, dictName, isTree = false) {
    /*const cmDict = getModelState("cmDict");
    const dictKey = key.split(".")[1];
    const dictData = cmDict[dictKey];*/
    const dictData = getCmDict(key)
    if (dictData) {
        if (isTree) {
            const getTreeDictCodeByName = (treeData = []) => {
                treeData.forEach(el => {
                    if (el.label === dictName) {
                        return el.value;
                    } else if (el.children && el.children.length > 0) {
                        getTreeDictCodeByName(el.children);
                    }
                })
                return null;
            }
            getTreeDictCodeByName(dictData);
        } else {
            const dict = dictData.find(el => el.label === dictName);
            return !!dict ? dict.key : null
        }

    }
    return null;
}

export function formatNum(num) {
    if (num === undefined || num === null) {
        num = 0.00;
    }
    if (typeof num === 'number') {
        num += '';
    }


    num = num.replace(/[^0-9|\.]/g, ''); //清除字符串中的非数字非.字符

    if (/^0+/) //清除字符串开头的0
        num = num.replace(/^0+/, '');
    if (!/\./.test(num)) //为整数字符串在末尾添加.00
        num += '.00';
    if (/^\./.test(num)) //字符以.开头时,在开头添加0
        num = '0' + num;
    num += '00'; //在字符串末尾补零
    num = num.match(/\d+\.\d{2}/)[0];
    return num;
}


export const getDictMeta = (code) => {
    return DICT_KEY.CM_DICT_META.find(el => el.CODE === code);
}
export const getDictMetaName = (code) => {
    const dict = getDictMeta(code);
    if (dict) {
        return dict.NAME;
    }
    return null;
}

export const resolveRefreshDictMethod = (code) => {
    let name = getDictMetaName(code);
    if (name) {
        name = "get" + name.charAt(0).toUpperCase() + name.slice(1)
    }
    return name;
}
export const refreshDict = async (code, dictModel) => {
    let methodName = resolveRefreshDictMethod(code);
    if (methodName) {
        let func = dictModel[methodName];
        // console.log(`准备执行更新函数${methodName}...`)
        // console.log(methodName);
        return await func.apply(dictModel, [true]);
    } else {
        console.log("更新方法不存在!")
    }
}


export function scmPrint(content) {
    const printFrame = document.getElementById("print-iframe");
    const doc = printFrame.contentWindow.document;
    doc.write(content);
    doc.close();
    printFrame.contentWindow.focus();
    printFrame.contentWindow.print();

}